import {
    React,
    useState,
    useEffect,
    useParams,
    Box,
    DataGrid,
    GridColDef,
    Dayjs,
    dayjs,
    Grid2,
    IconButton,
    ModeEditOutlineIcon,
    AddCommentIcon,
    Tooltip,
    ViewCompactAltIcon
} from '../../../utils/globalImports';

import {
    SearchBar,
    CustomButton,
    useApi,
    CustomDatePicker,
    Toaster,
    validationMessages,
    CustomBackdrop,
    ViewInstructionComments,
    AddEditCommentsReferenceModal
} from '../../../utils/globalImports';

import { ApiResponse } from '../../../services/apiService';
import { isAdmin } from '../../../interfaces/userRoles';


interface Instructions {
    id?: number;
    proposalId?: number;
    instructedFeeStageId: number;
    createdDate?: Dayjs | null;
    updatedDate?: Dayjs | null;
    description?: string;
    instructionValue?: number;
    poAmount?: number;
    createdBy?: string;
    instructionReference?: string;
    comment?: string;
}

interface Comment {
    id?: number;
    instructedFeeStageId: number;
    // createdDate: Dayjs | null;
    // updatedDate: Dayjs | null;
    // instructionValue: number,
    createdId: number;
    // instructionReference?: string;
    note: string;
}


const ProposalInstructionLog: React.FC = () => {

    const [query, setQuery] = useState("");
    const [date, setDate] = useState<Dayjs | null>(null);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [feeStageOption, setFeeStageOption] = useState<any[]>([]);
    const [referenceComment, setReferenceComment] = useState<any | null>(null);
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });

    const [modal, setModal] = useState({
        open: false,
        instructionReference: '',
        isComments: false
    });

    const [modalViewComment, setModalViewComment] = useState({
        open: false,
        feeStgaeId: 0
    });

    const { execute, loading } = useApi();

    const userId = Number(localStorage.getItem("userId"));
    const { proposalId } = useParams<{ proposalId?: string }>(); // Get proposalId from URL

    const columns: GridColDef<(typeof feeStageOption)[number]>[] = [
        {
            field: 'createdDate', headerName: 'Date and time', flex: 1, headerAlign: 'left',
            align: 'center',
            valueFormatter: (params: any) =>
                dayjs(params as string).format('DD-MM-YYYY HH:mm:ss'),
        },
        {
            field: 'description', headerName: 'Type', flex: 1, headerAlign: 'left',
            align: 'center',
        },
        {
            field: 'instructionReference', headerName: 'Reference', flex: 1, headerAlign: 'left',
            align: 'center',
        },
        {
            field: 'instructionValue', headerName: 'Value', flex: 1, headerAlign: 'left',
            align: 'center',
            valueFormatter: (params) => {
                const value = params as number;
                return value.toLocaleString('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                });
            },
        },
        {
            field: 'poAmount', headerName: 'PO Amount', flex: 1, headerAlign: 'left',
            align: 'center',
            valueFormatter: (params) => {
                const value = params as number;
                return value.toLocaleString('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                });
            },
        },

        {
            field: 'createdBy', headerName: 'Created by', flex: 1, headerAlign: 'left',
            align: 'center',
        },
        {
            field: 'comment', headerName: 'Comments', flex: 1, headerAlign: 'left',
            align: 'center',
        },
        {
            field: '', headerName: 'Actions', flex: 1, headerAlign: 'left',
            align: 'center', sortable: false,
            renderCell: (params) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'left',
                    alignItems: 'left',
                    gap: 1,
                    marginTop:'10px',
                    width: '100%'
                }}>

                    {isAdmin() && (
                        <Tooltip title="Edit Reference">
                            <IconButton
                                color="primary"
                                aria-label="edit"
                                onClick={() => onRowReferenceEdit(params.row)}
                            >
                                <ModeEditOutlineIcon sx={{ color: '#a3c63d' }} />
                            </IconButton>
                        </Tooltip>
                    )}

                    <Tooltip title="Add Comment">
                        <IconButton color="primary" aria-label="edit"
                            onClick={() => onRowAddComment(params.row)}
                        >
                            <AddCommentIcon sx={{ color: '#a3c63d' }} ></AddCommentIcon>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="View Comments">
                        <IconButton color="primary" aria-label="edit"
                            onClick={() => onRowViewComments(params.row)}
                        >
                            <ViewCompactAltIcon sx={{ color: '#a3c63d' }} ></ViewCompactAltIcon>
                        </IconButton>
                    </Tooltip>

                </div>
            ),
        },
    ];


    useEffect(() => {
        fetchInstructions();
    }, []);  // The empty dependency array ensures it only runs once when the component mounts

    // Fetch Instructions
    const fetchInstructions = async () => {
        const { data } = await execute<Instructions[]>('get', `Proposal/${proposalId}/Instructionslogs`);
        if (data) {
            // Use reduce to exclude unwanted fields
            // const instructionData = data
            //     .map((instruction) => {
            //         const {
            //             instructedFeeStageId,
            //             createdDate,
            //             instructionValue,
            //             createdBy,
            //             instructionReference,
            //             comment
            //         } = instruction;

            //         return {
            //             instructedFeeStageId,
            //             "Date and time": createdDate,
            //             "Value": instructionValue,
            //             "Reference": instructionReference,
            //             "Created by": createdBy,
            //             "Comments": comment,
            //         };
            //     });

            // const sortedData = instructionData.sort((a, b) =>
            //     dayjs(a["Date and time"]).diff(dayjs(b["Date and time"]))
            // );
            setFeeStageOption(data);
            setFilteredData(data);
        }
    };

    const onRowReferenceEdit = (row: any) => {
        setReferenceComment(row)
        console.log(row)
        setModal({
            open: true,
            instructionReference: row.instructionReference,
            isComments: false
        })
    }

    const onRowAddComment = (row: any) => {
        setReferenceComment(row)
        setModal({
            open: true,
            instructionReference: '',
            isComments: true
        })
    }

    const onRowViewComments = (row: any) => {
        console.log(row)
        // setReferenceComment(row)
        setModalViewComment({
            open: true,
            feeStgaeId: row.instructedFeeStageId
        })
    }

    const handleAddEditCommentReference = async (formData: any) => {
        let response: ApiResponse<any>;
        if (modal.isComments) {

            const AddComment: Comment = {
                note: formData.description,
                instructedFeeStageId: referenceComment.instructedFeeStageId,
                createdId: userId
            }

            response = await execute('post', `/InstructedFeeStageLogComments`, AddComment);
        }
        else {
            const updateReference: Instructions = {
                proposalId: Number(proposalId),
                instructedFeeStageId: referenceComment.instructedFeeStageId,
                instructionReference: formData.description
            };

            response = await execute('put', `/Proposal/${proposalId}/UpdateInstructionReference`, updateReference);
        }

        if (response!) {
            if (response.error) {
                // If there's an error in the response, display the error message
                setToast({ open: true, message: response.error, type: "error" });
            } else {
                // If the response is successful, display the success message
                setToast({ open: true, message: response.data, type: "success" });
                fetchInstructions()
                setReferenceComment(null)
                setModal({
                    open: false,
                    instructionReference: '',
                    isComments: false
                });
            }
        }
    }

    return (

        <>

            <Grid2 container spacing={2} sx={{ pt: 1 }}  >
                {/* Search Bar */}
                {/* <Grid2
                    size={{
                        xs: 12,
                        md: 6,
                        lg: 8
                    }}
                >
                    <SearchBar
                        placeholder={validationMessages.proposal_feestage_serachText}
                        onQueryChange={setQuery}
                        sx={{ boxShadow: "0px 4px 12px 4px #d7d7d7" }} />
                </Grid2> */}

                {/* status Dropdown */}
                <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                    {/* <CustomDatePicker
                        label="End Date"
                        value={date}
                        onChange={setDate}
                        height={43}
                        sx={{
                            boxShadow: "0px 4px 12px 6px #d7d7d7",
                            borderRadius: "50px",
                        }}
                    /> */}
                </Grid2>

                {/* serach button */}
                {/* <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                    <CustomButton
                        capsule
                        sx={{
                            mt: 0,
                            mb: 2,
                            textTransform: 'none'
                        }}
                        backgroundColor="#1e66ab"
                        hoverColor="rgba(150, 193, 33, 0.75)"
                        onClick={handleSearchClick} // Trigger search when clicked
                    >
                        Search
                    </CustomButton>
                </Grid2> */}
            </Grid2>

            {feeStageOption.length > 0 && (
                <Box
                    sx={{
                        height: 'calc(100vh - 250px)', // or whatever fits your layout
                        width: '100%',
                        bgcolor: 'white',
                        borderRadius: 2,
                        boxShadow: 4,
                        overflowX: 'auto',
                    }}
                >
                    <DataGrid
                        rows={feeStageOption}
                        columns={columns}
                        getRowId={(row) => row.instructedFeeStageId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 100,
                                },
                            },
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                fontSize: '16px',
                                color: '#1e66ab'
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '14px',
                                color: '#1e66ab',
                                textAlign: 'left',
                                justifyContent: 'center',
                            },

                        }}
                        pageSizeOptions={[5]}

                    />
                </Box>
            )}

            {/* )} */}

            <CustomBackdrop
                open={loading}
            />

            <AddEditCommentsReferenceModal
                open={modal.open}
                instructionReference={modal.instructionReference}
                isComments={modal.isComments}
                onClose={() => {
                    setModal({
                        open: false,
                        instructionReference: '',
                        isComments: false
                    });
                    setReferenceComment(null);
                }}
                onSubmit={handleAddEditCommentReference}
            >

            </AddEditCommentsReferenceModal >

            {modalViewComment.open && (
                <ViewInstructionComments
                    open={modalViewComment.open}
                    onClose={() => {
                        setModalViewComment({
                            open: false,
                            feeStgaeId: 0
                        });
                        setReferenceComment(null);
                    }}
                    instructedFeeStageID={modalViewComment.feeStgaeId}
                >

                </ViewInstructionComments>
            )}



            <Toaster
                open={toast.open}
                message={toast.message}
                type={toast.type as "success" | "error"}
                onClose={() => setToast({ ...toast, open: false })}
            />
        </>

    );
}

export default ProposalInstructionLog;